export const environment = {
  production: false,
  inBrowser: false,
  name: 'test',
  aem: '', // host AEM
  api: 'https://release.dxl-pre.vodafone.it', // host API
  apiKeycloak: 'https://keycloak.dxl-pre.vodafone.it', // host API keycloak
  apiBasePath: 'api-biz',
  resource: '/etc.clientlibs/myvf-business/clientlibs/myvf-business-webview/resources',
  apiAWS: 'https://business.api.mvacloud-dev.vodafone.it/test',
  aemBasePath:'https://mva-business-pre.vodafone.it',
  apiProcessFlow: 'https://eks.webcloud-dev.vodafone.it/dxl/dev'
};
